import _set from 'lodash/set';

import { MutationTree } from "vuex";
import { InspectorsState } from "./types";
import { Inspector } from "@/models";
import _ from 'lodash';

/**
 * Mutations
 *
 * The only way to actually change state in a Vuex store is by committing a mutation.
 * - Vuex mutations are very similar to events: each mutation has a string type and a handler.
 * - The handler function is where we perform actual state modifications - it receives the state as the first argument:
 * - You cannot directly call a mutation handler.
 * - Think of it more like event registration: "When a mutation with type X is triggered, call this handler."
 * - To invoke a mutation handler, you need to call store.commit with its type e.g. `store.commit('setUser', user)`
 */
export const mutations: MutationTree<InspectorsState> = {

	/**
	 * Set the Inspectors list
	 * 
	 * @param {InspectorsState} state
	 * @param {Inspector[]} Inspectors
	 * @returns void
	 */
	setInspectors(state: InspectorsState, Inspectors: Inspector[]): void {
		state.list = Inspectors;
	},

	/**
	 * Set current Inspector
	 * 
	 * @param {InspectorsState} state
	 * @param {Inspector} Inspector
	 * @returns void
	 */
	setCurrent(state: InspectorsState, Inspector: Inspector): void {
		state.current = Inspector;
	},

	/**
   * Set current page
   *
   * @param state ReportsState
   * @param currentPage number
   * @returns void
   */
	setCurrentPage(state: InspectorsState, currentPage: number): void {
		state.currentPage = currentPage;
	},

	/**
	 * Set the currently edited/viewed Inspector
	 */
	setInspectorsDeep(state: InspectorsState, payload: { path: string, data: any }): void {
		state.current = Object.assign(new Inspector, _set(state.current, payload.path, payload.data));
	},

	/**
	 * ++ Unsaved changes
	 * 
	 * @param state InspectorsState
	 * @param element string
	 * @returns void
	 */
	addUnsavedChange(state: InspectorsState, element: string): void {
		state.updates = [...new Set(state.updates.concat([element]))];
	},

	/**
	  * Reset Unsaved changes
	  * 
	  * @param state InspectorsState
	  * @returns void
	  */
	resetUnsavedChanges(state: InspectorsState): void {
		state.updates = [];
	},

	resetState(state: InspectorsState): void {
		state.current = new Inspector;
		state.list = [];
		state.updates = [];
	},

	rehydrateState(state: InspectorsState): void {
		state.current = new Inspector(state.current);
		state.list = state.list.map((x: any) => new Inspector(x));
	}

}
